<template>
  <div class="search_result_box">
    <div class="sort flex" v-if="fetch_data.posts.length > 0">
      <p>並び替え</p>
      <select v-model="order" v-on:change="$emit('orderChanged', order)">
        <option value="published_at_desc">開催の新しい順</option>
        <option value="published_at_asc">開催の古い順</option>
      </select>
    </div>
    <div class="search_result">
      <div class="result_box" v-for="(post, key) in fetch_data.posts" :key="key" v-bind:id="'event-' + post.id"
           @click="permalinkUrl(post)">
        <div class="tag" style="width: fit-content; margin-bottom: 6px">{{ post.category_name }}</div>
        <div class="header flex">
          <div class="detail flex">
            <div class="icon">
              <img v-bind:src="eventImageUrl(post)">
            </div>
            <div class="inner">
              <div class="room_name">
                {{ post.title }}
              </div>
              <div class="date">{{ moment(post.open_date, 'YYYY/MM/DD') }}</div>
            </div>
          </div>
        </div>
        <div class="link_area">
          <div class="title" v-if="false"></div>
          <div class="text_body" v-html="post.body_hit_text"></div>
        </div>
      </div>
      <template v-if="fetch_data.posts.length === 0">
        <div class="mt20 mb20 alnC">
          一致する投稿は見つかりませんでした。
        </div>
      </template>
      <template v-else>
        <Pagination :pagination="fetch_data.pagination" v-on:changed="$emit('pageChanged', $event)"/>
      </template>
    </div>
  </div>
</template>

<script>
import Libraries from '@/components/Libraries.vue'
import Pagination from "@/components/Pagination.vue";

export default {
  components: {Pagination},
  mixins: [Libraries],
  props: {
    fetch_data: null,
    tab: null,
    order: null,
  },
  methods: {
    eventUrl(post) {
      if (post.event === 'workshop') {
        return {name: 'WorkshopList', params: {category: post.category_uri}}
      } else {
        return {name: 'GetsureiList'}
      }
    },
    permalinkUrl(post) {
      if (post.event === 'workshop') {
        this.$router.push({name: 'WorkshopShow', params: {category: post.category_uri, id: post.id}, query: {query: this.fetch_data.query}})
      } else {
        this.$router.push({name: 'GetsureiShow', params: {id: post.id}, query: {query: this.fetch_data.query}})
      }
    },
    eventImageUrl(post) {
      if (post.event === 'workshop') {
        if (post.category_uri === 'camp_camp' || post.category_uri === 'camp_tour') {
          return '/common/images/mmicon_tour.png'
        } else {
          return '/common/images/mmicon_kenshu.png'
        }
      } else {
        return '/common/images/mmicon_getsurei.png'
      }
    }
  }
}
</script>